<template>
    <div style="height: 500px; overflow-y: auto;">
        <div style="display:flex;">
            <div style="flex-grow:1;">

                <div class="input-row">
                    <input id="maintainSideGrading_GarageSide" type="checkbox" v-model="maintainingOptions.maintainSideGrading_GarageSide">
                    <label for="maintainSideGrading_GarageSide" style="text-align: initial;margin-left: 20px;">Maintain Side Grading "Garage Side"</label>
                </div>
                <div class="img-container" v-if="maintainingOptions.maintainSideGrading_GarageSide">
                    <img src="@/assets/maintainSideGarage.png" style="margin:5px">
                    <label class="maintain-distance" style="left: 545px;top: 282px;" @click="fillDistanceToMaintainOnSide_GarageSide()">{{ maintainingOptions.distanceToMaintainOnSide_GarageSide? maintainingOptions.distanceToMaintainOnSide_GarageSide + "'" : '??' }}</label> 
                    <label class="maintain-distance" style="left: 375px;top: 282px;" @click="fillDistanceToGradeOnSide_GarageSide">{{ maintainingOptions.distanceToGradeOnSide_GarageSide? maintainingOptions.distanceToGradeOnSide_GarageSide + "'" : '??' }}</label> 
                </div>

                <div style="height: 10px;"></div>
               
                <div class="input-row">
                    <input id="maintainSideGrading_NonGarageSide" type="checkbox" v-model="maintainingOptions.maintainSideGrading_NonGarageSide">
                    <label for="maintainSideGrading_NonGarageSide" style="text-align: initial;margin-left: 20px;">Maintain Side Grading "Non Garage Side"</label>
                </div>
                <div class="img-container" v-if="maintainingOptions.maintainSideGrading_NonGarageSide">
                    <img src="@/assets/maintainSideNonGarage.png" style="margin:5px">
                    <label class="maintain-distance" style="left: 545px;top: 285px;" @click="fillDistanceToMaintainOnSide_NonGarageSide()">{{ maintainingOptions.distanceToMaintainOnSide_NonGarageSide? maintainingOptions.distanceToMaintainOnSide_NonGarageSide + "'" : '??' }}</label> 
                    <label class="maintain-distance" style="left: 375px;top: 285px;" @click="fillDistanceToGradeOnSide_NonGarageSide()">{{ maintainingOptions.distanceToGradeOnSide_NonGarageSide? maintainingOptions.distanceToGradeOnSide_NonGarageSide + "'" : '??' }}</label> 
                </div>
                <div style="height: 10px;"></div>
                
                <div class="input-row">
                    <input id="maintainRearGrading" type="checkbox" v-model="maintainingOptions.maintainRearGrading">
                    <label for="maintainRearGrading" style="text-align: initial;margin-left: 20px;">Maintain Rear Grading</label>
                </div>
                <div class="img-container" v-if="maintainingOptions.maintainRearGrading">
                    <div class="red-warning">Works only when "Wrap Rear Corners" in previous page is OFF</div>
                    <img src="@/assets/maintainRear.png" style="margin:5px">
                    <label class="maintain-distance"  style="left: 299px;top: 272px;" @click="fillDistanceToMaintainOnRear_GarageSide()">{{ maintainingOptions.distanceToMaintainOnRear_GarageSide? maintainingOptions.distanceToMaintainOnRear_GarageSide + "'" : '??' }}</label> 
                    <label class="maintain-distance"  style="left: 428px;top: 272px;" @click="fillDistanceToMaintainOnRear_MiddleArea()">{{ maintainingOptions.distanceToMaintainOnRear_MiddleArea? maintainingOptions.distanceToMaintainOnRear_MiddleArea + "'" : '??' }}</label> 
                    <label class="maintain-distance"  style="left: 576px;top: 272px;" @click="fillDistanceToMaintainOnRear_NonGarageSide()">{{ maintainingOptions.distanceToMaintainOnRear_NonGarageSide? maintainingOptions.distanceToMaintainOnRear_NonGarageSide + "'" : '??' }}</label> 
                </div>
            </div>
            <div style="height:500px;position:relative;">
            </div>
        </div>
    </div>
    </template>
    
    <script>
    import { mapState } from "vuex";
    
    export default {
        name: 'MaintainingOptions',
        data: () => ({
        }),
        methods: {
            fillLength(length){
                if(!length)
                    length = '';
                let numberString = prompt("Write a length in feet :",length);
                var number  = parseFloat(numberString)
                if(isNaN(number))
                    return null;
                if(!number)
                    number = null;
                return number;
            },
            fillDistanceToMaintainOnSide_GarageSide(){
                var number = this.fillLength(this.maintainingOptions.distanceToMaintainOnSide_GarageSide)
                this.maintainingOptions.distanceToMaintainOnSide_GarageSide = number;
                this.maintainingOptions.distanceToGradeOnSide_GarageSide = null;
           },
           fillDistanceToGradeOnSide_GarageSide(){
                var number = this.fillLength(this.maintainingOptions.distanceToGradeOnSide_GarageSide)
                this.maintainingOptions.distanceToGradeOnSide_GarageSide = number;
                this.maintainingOptions.distanceToMaintainOnSide_GarageSide = null;
           },
           fillDistanceToMaintainOnSide_NonGarageSide(){
                var number = this.fillLength(this.maintainingOptions.distanceToMaintainOnSide_NonGarageSide)
                this.maintainingOptions.distanceToMaintainOnSide_NonGarageSide = number;
                this.maintainingOptions.distanceToGradeOnSide_NonGarageSide = null;
           },
           fillDistanceToGradeOnSide_NonGarageSide(){
                var number = this.fillLength(this.maintainingOptions.distanceToGradeOnSide_NonGarageSide)
                this.maintainingOptions.distanceToGradeOnSide_NonGarageSide = number;
                this.maintainingOptions.distanceToMaintainOnSide_NonGarageSide = null;
           },
           fillDistanceToMaintainOnRear_NonGarageSide(){
                var number = this.fillLength(this.maintainingOptions.distanceToMaintainOnRear_NonGarageSide)
                this.maintainingOptions.distanceToMaintainOnRear_NonGarageSide = number;
                if(!!this.maintainingOptions.distanceToMaintainOnRear_MiddleArea && !!this.maintainingOptions.distanceToMaintainOnRear_GarageSide){
                    this.maintainingOptions.distanceToMaintainOnRear_MiddleArea = null;
                    this.maintainingOptions.distanceToMaintainOnRear_GarageSide = null;
                }
           },
           fillDistanceToMaintainOnRear_MiddleArea(){
                var number = this.fillLength(this.maintainingOptions.distanceToMaintainOnRear_MiddleArea)
                this.maintainingOptions.distanceToMaintainOnRear_MiddleArea = number;
                if(!!this.maintainingOptions.distanceToMaintainOnRear_NonGarageSide && !!this.maintainingOptions.distanceToMaintainOnRear_GarageSide){
                    this.maintainingOptions.distanceToMaintainOnRear_NonGarageSide = null;
                    this.maintainingOptions.distanceToMaintainOnRear_GarageSide = null;
                }
           },
           fillDistanceToMaintainOnRear_GarageSide(){
                var number = this.fillLength(this.maintainingOptions.distanceToMaintainOnRear_GarageSide)
                this.maintainingOptions.distanceToMaintainOnRear_GarageSide = number;
                if(!!this.maintainingOptions.distanceToMaintainOnRear_NonGarageSide && !!this.maintainingOptions.distanceToMaintainOnRear_MiddleArea){
                    this.maintainingOptions.distanceToMaintainOnRear_NonGarageSide = null;
                    this.maintainingOptions.distanceToMaintainOnRear_MiddleArea = null;
                }
           }
        },
        computed: {
            ...mapState({
                maintainingOptions: (state) => state.currentGradingTemplate.maintainingOptions,
            }),
        }
    }
    </script>
    
    <style lang="scss" scoped>
    @import '@/scss/variables.scss';
     
    .input-row {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 5px 25px;
    }
    
    .img-container{
        position: relative;
    }
    .maintain-distance{
        color: blue;
        cursor: pointer;
        position: absolute;
    }
    .maintain-distance:hover{
        text-decoration: underline;
    }
    .red-warning{
        color: red;
        text-align: left;
        margin-left: 64px;
        font-size: 13px;
        font-style: italic;
    }
    </style>
    